"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFundName = exports.fundsName = void 0;
exports.fundsName = {
    globalGrowth: 'Blum Renta Global',
    globalCapital: 'Blum Capital Global',
    globalCash: 'Blum Cash',
    globalCashPEN: 'Blum Cash Soles',
    moneyMarketUSD: 'Blum Money Market Dólares',
    moneyMarketPEN: 'Blum Money Market Soles',
    globalBondsUSD: 'Blum Bonos Globales',
    usa500USD: 'Blum USA 500 Acciones',
    blumPiano: 'Blum Piano I',
    dynamicMacroUSD: 'Blum Dynamic Macro Strategy',
};
const getFundName = (key) => {
    if (key === undefined || key === null) {
        return '';
    }
    return exports.fundsName[key] || '';
};
exports.getFundName = getFundName;
//# sourceMappingURL=funds.js.map